export default {
  "content": "<g clip-path=\"url(#icon_trash_outlined_svg__a)\"><path d=\"M15.5 3.5H12v-2c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v2H.5c-.28 0-.5.22-.5.5s.22.5.5.5H2v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-10h1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zM5 1.5h6v2H5v-2zm8 13H3v-10h10v10z\"/><path d=\"M5.5 9.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.28-.22-.5-.5-.5zm2.5-2c-.28 0-.5.22-.5.5v5c0 .28.22.5.5.5s.5-.22.5-.5V8c0-.28-.22-.5-.5-.5zm2.5 2c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.28-.22-.5-.5-.5z\"/></g><defs><clipPath id=\"icon_trash_outlined_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};